
let TestModel = require('@/mixins/Forms/2019/TestModel')

module.exports = {

    mixins: [TestModel],

    data(){
        return {
            construction_inspection: {
                name: `A. Construction Inspection (NA7.6.3.1)`,
                questions: {
                    question_1: {
                        id: `a`,
                        question: `The demand responsive control is capable of receiving a demand responsive signal directly or indirectly through another device. (NA7.6.3.1(a))`,
                        answer: false,
                    },
                    question_2: {
                        id: `b`,
                        question: `The demand responsive control is a certified <a class="text-info" href="https://products.openadr.org/" target="_blank">OpenADR 2.0a</a> or <a class="text-info" href="https://products.openadr.org/" target="_blank">OpenADR 2.0b</a> Virtual End Node (VEN), as specified under Clause 11, Conformance, in the applicable <a class="text-info" href="https://products.openadr.org/" target="_blank">OpenADR 2.0</a> Specification. (NA7.6.3.1(a), §110.12(a)1A).<br><b>OR</b><br>The demand responsive control is certified by the manufacturer to the Energy Commission as being capable of responding to a demand response signal from a certified <a class="text-info" href="https://www.energy.ca.gov/rules-and-regulations/building-energy-efficiency/manufacturer-certification-building-equipment-3" target="_blank">OpenADR 2.0b</a> VEN by automatically implementing the control functions requested by the VEN for the equipment it controls. (NA7.6.3.1(a), Section 110.12(a)1B)`,
                        answer: false
                    },
                    question_3: {
                        id: `c`,
                        question: `The demand responsive control is capable of communicating using one or more of the following: Wi-Fi, ZigBee, BACnet, Ethernet, or hard-wiring. (NA7.6.3.1(a), Section 110.12(a)2)`,
                        answer: false
                    },
                    question_4: {
                        id: `d`,
                        question: `The demand responsive control continues to perform all other functions provided by the control when communications are disabled or unavailable. (NA7.6.3.1(a), Section 110.12(a)4)`,
                        answer: false,
                    },
                    question_5: {
                        id: `e`,
                        question: `If the demand response signal is received from another device (such as an EMCS), that system must itself be capable of receiving a demand response signal from a utility meter or other external source. (NA7.6.3.1(b))`,
                        answer: false
                    },
                },
                result: false,
            }
        }
    },

    mounted() {
        this.form = new Form({
            construction_inspection: this.construction_inspection,
            functional_test: this.functional_test,
            comments: '',
            testResult: false,
        }, false)
        this.loadFormData();
    },

    methods: {

        initTest() {

            if (!this.testIsReady) {
                return;
            }

            this.constructionInspectionEvaluation();
            this.functionalTestEvaluation();

            this.form.testResult = (this.form.construction_inspection.result && this.form.functional_test.result);
        },

        constructionInspectionEvaluation() {
            this.form.construction_inspection.result = true;
            _.each(this.form.construction_inspection.questions, (question, i) => {
                if (!question.answer) {
                    this.form.construction_inspection.result = false;
                }
            })
        },

        functionalTestEvaluation() {
            // Needs to be called from the test component.
        },


        hasMergedCells(question) {
            if (question.hasOwnProperty('merge_cells')) {
                return question.merge_cells;
            }
            return false;
        }
    },
}
